import { httpReducer, reduceReducers } from "../lib/create-action";
import {
  publicShowActionName,
  getPublicShowsForSubscriberActionName,
  getPublicShowsByUUIDs,
} from "../action_managers/public_show";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import keyBy from "lodash/keyBy";
import { GET_SAMPLE_AD_READ } from "../action_managers/campaigns";

const initialState = { isLoading: false, userIndexes: {}, adReadsByShowUUID: {} };

const publicShowReducer = httpReducer(publicShowActionName, initialState, {
  success: (state, action) => {
    let newState = cloneDeep(state);
    if (get(action, "data.userUUID")) {
      newState.userIndexes[action.data.userUUID] = action.payload.resp.map(item => item.uuid);
      action.payload.resp.forEach(show => {
        newState[show.uuid] = show;
      });
    } else {
      newState[action.payload.resp.uuid] = action.payload.resp;
    }
    return newState;
  },
});

const subscribedShowReducer = httpReducer(getPublicShowsForSubscriberActionName, initialState, {
  success: (state, action) => ({
    ...state,
    [action.payload.resp.uuid]: action.payload.resp,
  }),
});

const fetchPublicShowsByUUIDs = httpReducer(getPublicShowsByUUIDs, initialState, {
  success: (state, action) => ({
    ...state,
    ...keyBy(action.payload.resp, "uuid"),
  }),
});

const getSampleAdReads = httpReducer(GET_SAMPLE_AD_READ, initialState, {
  success: (state, action) => ({
    ...state,
    adReadsByShowUUID: {
      ...state.adReadsByShowUUID,
      [action.data.showUUID]: action.payload.resp,
    },
  }),
});

export default reduceReducers(
  publicShowReducer,
  subscribedShowReducer,
  fetchPublicShowsByUUIDs,
  getSampleAdReads
);
